import React from "react";
import ListAlt from "@mui/icons-material/ListAlt";
import { checkout_form } from "repoV2/features/CheckoutPages/modules/PaymentDetailsSection/modules/CheckoutForm/CheckoutForm.constants";
import styles from "./UserDetailsFormGroupHeader.module.scss";

const {
    user_details: { title },
} = checkout_form;

const UserDetailsFormGroupHeader = () => {
    return (
        <div className={styles.Wrapper}>
            <ListAlt className={styles.headerIconStyle} />
            <div className={styles.TitleText}>{title}</div>
        </div>
    );
};

export default UserDetailsFormGroupHeader;
